// components/PartnerNavbar.tsx
"use client";
import { useState } from "react";
import "./partnerStyle.css";

export default function PartnerNavbar({
  title = "Partner Portal",
  userName = "",
  onProfile = () => {},
  onLogout = () => {},
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      {/* Fixed Navbar */}
      <header className="ps-navbar" role="banner">
        <div className="ps-nav-inner">
          {/* Logo + Title */}
          <div className="ps-brand">
            <div className="ps-logo-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <circle cx="16" cy="16" r="12" stroke="#ea8716" strokeWidth="3"/>
                <path d="M8 16L13 21L24 10" stroke="#ea8716" strokeWidth="3" strokeLinecap="round"/>
              </svg>
            </div>
            <h1 className="ps-title">{title}</h1>
          </div>

          {/* Desktop: User Info + Actions */}
          <div className="ps-user-section-desktop">
            <div className="ps-user-info">
              <div className="ps-avatar">
                {userName.charAt(0).toUpperCase() || "P"}
              </div>
              <div className="ps-user-details">
                <span className="ps-greeting">Hello,</span>
                <span className="ps-username">{userName || "Partner"}</span>
              </div>
            </div>

            <div className="ps-actions">
              <button onClick={onProfile} className="ps-btn ps-btn-profile">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                Profile
              </button>

              <button
                onClick={() => window.confirm("Are you sure you want to logout?") && onLogout()}
                className="ps-btn ps-btn-logout"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                  <polyline points="16 17 21 12 16 7"></polyline>
                  <line x1="21" y1="12" x2="9" y2="12"></line>
                </svg>
                Logout
              </button>
            </div>
          </div>

          {/* Mobile: Hamburger */}
          <button
            className="ps-mobile-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
            aria-expanded={mobileMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>

      {/* Mobile Slide-in Menu */}
      <div className={`ps-mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
        {/* Close Button (X) */}
        <button
          className="ps-mobile-close"
          onClick={() => setMobileMenuOpen(false)}
          aria-label="Close menu"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 6L6 18"></path>
            <path d="M6 6l12 12"></path>
          </svg>
        </button>

        <div className="ps-mobile-header">
          <div className="ps-avatar large">
            {userName.charAt(0).toUpperCase() || "P"}
          </div>
          <div>
            <div className="ps-greeting">Hello,</div>
            <div className="ps-username large">{userName || "Partner"}</div>
          </div>
        </div>

        <button onClick={onProfile} className="ps-mobile-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          Profile Settings
        </button>

        <button
          onClick={() => {
            setMobileMenuOpen(false);
            if (window.confirm("Are you sure you want to logout?")) onLogout();
          }}
          className="ps-mobile-btn logout"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          Logout
        </button>
      </div>

      {/* Backdrop Overlay */}
      {mobileMenuOpen && (
        <div className="ps-mobile-overlay" onClick={() => setMobileMenuOpen(false)} />
      )}
    </>
  );
}